import React from 'react';
import noop from 'lodash/noop';

export default class IntervalRunner extends React.PureComponent {
  static defaultProps = {
    isActive: false,
    interval: 30, // seconds
    action: noop,
  };

  intervalId = null;

  componentDidMount() {
    this.start();
  }

  componentDidUpdate(prevProps) {
    const {
      isActive: prevIsActive,
      action: prevAction,
      interval: prevInterval,
    } = prevProps;
    const { isActive, action, interval } = this.props;

    if (
      prevIsActive !== isActive ||
      prevInterval !== interval ||
      prevAction !== action
    ) {
      this.restart();
    }
  }

  componentWillUnmount() {
    this.stop();
  }

  // Methods
  start = () => {
    const { isActive, interval, action } = this.props;

    if (isActive) {
      this.intervalId = window.setInterval(action, interval * 1000);
    }
  };

  stop = () => {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  };

  restart = () => {
    this.stop();
    this.start();
  };

  render() {
    return this.props.children;
  }
}